webpackJsonp([202660965941462],{

/***/ 208:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(15);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _reactstrap = __webpack_require__(25);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Project = function Project(_ref) {
	    var pictureSrc = _ref.pictureSrc,
	        title = _ref.title,
	        description = _ref.description,
	        linkUrl = _ref.linkUrl,
	        _ref$technologies = _ref.technologies,
	        technologies = _ref$technologies === undefined ? [] : _ref$technologies,
	        role = _ref.role,
	        year = _ref.year;
	    return _react2.default.createElement(
	        _reactstrap.Row,
	        { className: 'projects-project' },
	        _react2.default.createElement(
	            _reactstrap.Col,
	            { md: '4' },
	            _react2.default.createElement('img', { src: pictureSrc, alt: 'Screenshot for project ' + title })
	        ),
	        _react2.default.createElement(
	            _reactstrap.Col,
	            { md: '8' },
	            _react2.default.createElement(
	                'h3',
	                null,
	                title
	            ),
	            !!linkUrl && _react2.default.createElement(
	                'p',
	                { className: 'link' },
	                _react2.default.createElement(
	                    'a',
	                    { href: linkUrl, target: '_blank' },
	                    linkUrl.replace('https://', '').replace('http://', ''),
	                    ' ',
	                    _react2.default.createElement('i', { className: 'fa fa-external-link' })
	                )
	            ),
	            _react2.default.createElement(
	                'p',
	                null,
	                description
	            ),
	            !!role && _react2.default.createElement(
	                'p',
	                null,
	                _react2.default.createElement(
	                    'b',
	                    null,
	                    'Role: '
	                ),
	                role
	            ),
	            !!year && _react2.default.createElement(
	                'p',
	                null,
	                _react2.default.createElement(
	                    'b',
	                    null,
	                    'Year: '
	                ),
	                year
	            ),
	            technologies.length > 0 && _react2.default.createElement(
	                'p',
	                null,
	                _react2.default.createElement(
	                    'b',
	                    null,
	                    'Technologies:'
	                )
	            ),
	            technologies.length > 0 && _react2.default.createElement(
	                'ul',
	                null,
	                technologies.map(function (t, i) {
	                    return _react2.default.createElement(
	                        'li',
	                        { key: i },
	                        t
	                    );
	                })
	            )
	        )
	    );
	};
	
	exports.default = Project;
	module.exports = exports['default'];

/***/ }),

/***/ 456:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/archivoschile.97c3b8aa.jpg";

/***/ }),

/***/ 457:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/atomix-js.169717f4.png";

/***/ }),

/***/ 458:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/black-tar-city.9dde446f.png";

/***/ }),

/***/ 459:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/bookmarc.25af110e.jpg";

/***/ }),

/***/ 460:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/cineducacion.7bde8b80.jpg";

/***/ }),

/***/ 215:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(15);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _PageHeader = __webpack_require__(56);
	
	var _PageHeader2 = _interopRequireDefault(_PageHeader);
	
	var _Page = __webpack_require__(54);
	
	var _Page2 = _interopRequireDefault(_Page);
	
	var _PageBody = __webpack_require__(55);
	
	var _PageBody2 = _interopRequireDefault(_PageBody);
	
	var _Project = __webpack_require__(208);
	
	var _Project2 = _interopRequireDefault(_Project);
	
	var _bookmarc = __webpack_require__(459);
	
	var _bookmarc2 = _interopRequireDefault(_bookmarc);
	
	var _archivoschile = __webpack_require__(456);
	
	var _archivoschile2 = _interopRequireDefault(_archivoschile);
	
	var _cineducacion = __webpack_require__(460);
	
	var _cineducacion2 = _interopRequireDefault(_cineducacion);
	
	var _atomixJs = __webpack_require__(457);
	
	var _atomixJs2 = _interopRequireDefault(_atomixJs);
	
	var _blackTarCity = __webpack_require__(458);
	
	var _blackTarCity2 = _interopRequireDefault(_blackTarCity);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Projects = function Projects() {
	    return _react2.default.createElement(
	        _Page2.default,
	        null,
	        _react2.default.createElement(_PageHeader2.default, { title: 'Projects' }),
	        _react2.default.createElement(
	            _PageBody2.default,
	            null,
	            _react2.default.createElement(
	                'div',
	                { id: 'main', className: 'site-main' },
	                _react2.default.createElement(
	                    'article',
	                    { className: 'page type-page status-publish hentry' },
	                    _react2.default.createElement(_Project2.default, {
	                        title: 'BlackTarCity',
	                        linkUrl: 'https://gabrielmerida.cl/demos/BlackTarCity/0.1/',
	                        description: _react2.default.createElement(
	                            'span',
	                            null,
	                            'A procedural city created using ReactJS and ThreeJs.',
	                            _react2.default.createElement('br', null),
	                            'Work in progress - beta version'
	                        ),
	                        role: 'programmer',
	                        year: '2018',
	                        technologies: ['ReactJS', 'Three.js', 'react-three-fiber', 'react-spring', 'canvas-sketch-utils', 'Storybook'],
	                        pictureSrc: _blackTarCity2.default
	                    }),
	                    _react2.default.createElement(_Project2.default, {
	                        title: 'Atomix-js',
	                        linkUrl: 'https://kafkiacode.github.io/atomix-js',
	                        description: _react2.default.createElement(
	                            'span',
	                            null,
	                            'Recreation in ReactJS of classic DOS/Commodore game ',
	                            _react2.default.createElement(
	                                'a',
	                                { href: 'https://en.wikipedia.org/wiki/Atomix_(video_game)', target: '_blank' },
	                                'Atomix'
	                            ),
	                            _react2.default.createElement('br', null),
	                            'Work in progress - beta version'
	                        ),
	                        role: 'Everything except original design.',
	                        year: '2018',
	                        technologies: ['ReactJS', 'Flow', 'Storybook', 'redux-saga'],
	                        pictureSrc: _atomixJs2.default
	                    }),
	                    _react2.default.createElement(_Project2.default, {
	                        title: 'bookmarc.io',
	                        linkUrl: 'https://bookmarc.io',
	                        description: 'Digital library based on Library, BackboneJS and React',
	                        role: 'Full stack developer (architecture, DB modelling, back-end programming, front-end programming, team leader).',
	                        year: '2014-2017',
	                        technologies: ['Laravel 5.1', 'BackboneJS', 'ReactJS', 'AWS', 'Elasticsearch'],
	                        pictureSrc: _bookmarc2.default
	                    }),
	                    _react2.default.createElement(_Project2.default, {
	                        title: 'Interactive Map: political executions in Chile, September 1973',
	                        linkUrl: 'http://archivoschile.org/2012/01/mapa-interactivo/',
	                        description: 'Data Driven Journalism project. Interactive map with cases of political victims of 1973 dictatorship.',
	                        role: 'Data Editor, UX design, programming',
	                        year: '2011',
	                        technologies: ['Javascript ES5', 'Google Maps API'],
	                        pictureSrc: _archivoschile2.default
	                    }),
	                    _react2.default.createElement(_Project2.default, {
	                        title: 'Cineducaci\xF3n (English: film-education)',
	                        linkUrl: 'http://cineducacion.cl',
	                        description: 'Interactive documentary. Integration of Vimeo and YouTube APIs.',
	                        role: 'Project Manager, additional front-end and javascript development',
	                        year: '2013',
	                        technologies: ['Javascript ES5', 'Google Maps API', 'YouTube/Vimeo API'],
	                        pictureSrc: _cineducacion2.default
	                    })
	                )
	            )
	        )
	    );
	};
	
	exports.default = Projects;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-projects-index-js-b62c048917f550d12ff0.js